// pages
export const AUTH = '';
export const MAIN = 'main';
export const HOTELS = 'hotels';
export const REPORTS = 'reports';
export const SERVICE = 'service';
export const SALES = 'sales';
export const PROBLEMS = 'problems';
export const BILLING = 'billing';
export const OFFLINE_HEADSETS = 'offline_headsets';
export const HEADSETS = 'headsets';
export const DEVICE_EVENTS = 'device_events';
export const METRICS = 'metrics';
export const ANALYTICS = 'analytics';
export const ABOUT = 'about';
export const SETTINGS = 'settings';
export const SUBSCRIPTION = 'subscriptions';
export const EVENTS = 'events';
export const USER_EVENTS = 'user_events';
export const PAYMENTS = 'payments';
export const COMMENTS = 'comments';
export const META = 'meta';
export const BATTERY_LOGS = 'battery_logs';

export const ACCESS_DENIED = 'access_denied';

export const pagesList: Record<string, string[]> = {
  [REPORTS]: [SALES, PROBLEMS, BILLING, OFFLINE_HEADSETS],
  [SERVICE]: [HEADSETS, DEVICE_EVENTS, ANALYTICS],
  [HOTELS]: [HEADSETS, METRICS, ANALYTICS, BILLING, ABOUT],
  [HEADSETS]: [
    SETTINGS,
    SUBSCRIPTION,
    BILLING,
    EVENTS,
    USER_EVENTS,
    PAYMENTS,
    COMMENTS,
    META,
    BATTERY_LOGS,
  ],
};
export const reportsPageMap: Record<string, string> = {
  [SALES]: 'pages.sales',
  [PROBLEMS]: 'pages.problems',
  [BILLING]: 'pages.billing',
  [OFFLINE_HEADSETS]: 'pages.offlineHeadsets',
};
export const servicePageMap: Record<string, string> = {
  [HEADSETS]: 'pages.headsets',
  [DEVICE_EVENTS]: 'pages.deviceEvents',
  [ANALYTICS]: 'pages.analytics',
};

export const hotelsPageMap: Record<string, string> = {
  [HEADSETS]: 'pages.headsets',
  [METRICS]: 'pages.metrics',
  [ANALYTICS]: 'pages.analytics',
  [BILLING]: 'pages.billing',
  [ABOUT]: 'pages.about',
};

export const headsetsPageMap: Record<string, string> = {
  [SETTINGS]: 'pages.settings',
  [SUBSCRIPTION]: 'pages.subscriptions',
  [BILLING]: 'pages.billing',
  [EVENTS]: 'pages.events',
  [USER_EVENTS]: 'pages.userEvents',
  [PAYMENTS]: 'pages.payments',
  [COMMENTS]: 'pages.comments',
  [META]: 'pages.logs',
  [BATTERY_LOGS]: 'pages.battery_logs',
};

export const ALL_ITEM_ID = '---all---';

// languagese
export const LANGUAGE = '__PAGE_LANGUAGE__';

export const HOTELS_VIEW_MODE = '__HOTELS_VIEW_MODE__';
export const HOTEL_CUSTOMER_SESSION = '__HOTEL_CUSTOMER_SESSION__';
